import Login from '../pages/Login';
import Home from '../pages/Home';
import ChangePw from '../pages/ChangePw';
import ForgotPw from '../pages/ForgotPw';
import Usuarios from '../pages/Usuarios';
import RegUsuarios from '../pages/RegUsuarios';
import Grupo_Usuarios from '../pages/Grupo_Usuarios';
import RegGrupo_Usuarios from '../pages/RegGrupo_Usuarios';
import Unidades from '../pages/Unidades';
import RegUnidades from '../pages/RegUnidades';
import Bancos from '../pages/Bancos';
import RegBancos from '../pages/RegBancos';
import Grupo_Conta from '../pages/Grupo_Conta';
import RegGrupo_Conta from '../pages/RegGrupo_Conta';
import Tipo_Conta from '../pages/Tipo_Conta';
import RegTipo_Conta from '../pages/RegTipo_Conta';
import Categoria_Representantes from '../pages/Categoria_Representantes';
import RegCategoria_Representantes from '../pages/RegCategoria_Representantes';
import Contas from '../pages/Contas';
import RegContas from '../pages/RegContas';
import Importacao from '../pages/Importacao';
import Clientes from '../pages/Clientes';
import RegClientes from '../pages/RegClientes';
import Contratos from '../pages/Contratos';
import RegContratos from '../pages/RegContratos';
import Paises from '../pages/Paises';
import RegPaises from '../pages/RegPaises';
import Estados from '../pages/Estados';
import RegEstados from '../pages/RegEstados';
import Cidades from '../pages/Cidades';
import RegCidades from '../pages/RegCidades';
import Representantes from '../pages/Representantes';
import RegRepresentantes from '../pages/RegRepresentantes';
import Categoria_Clientes from '../pages/Categoria_Clientes';
import RegCategoria_Clientes from '../pages/RegCategoria_Clientes';
import Bandeira_Cartao from '../pages/Bandeira_Cartao';
import RegBandeira_Cartao from '../pages/RegBandeira_Cartao';
import Campanhas from '../pages/Campanhas';
import RegCampanhas from '../pages/RegCampanhas';
import Formas_Pagamento from '../pages/Formas_Pagamento';
import RegFormas_Pagamento from '../pages/RegFormas_Pagamento';
import Motivos_Cancelamento from '../pages/Motivos_Cancelamento';
import RegMotivos_Cancelamento from '../pages/RegMotivos_Cancelamento';
import Situacao_Historico from '../pages/Situacao_Historico';
import RegSituacao_Historico from '../pages/RegSituacao_Historico';
import Tipo_Historico from '../pages/Tipo_Historico';
import RegTipo_Historico from '../pages/RegTipo_Historico';
import Tipo_Solicitacao from '../pages/Tipo_Solicitacao';
import RegTipo_Solicitacao from '../pages/RegTipo_Solicitacao';
import Tipo_FormaPagamento from '../pages/Tipo_FormaPagamento';
import RegTipo_FormaPagamento from '../pages/RegTipo_FormaPagamento';
import Tipo_Contrato from '../pages/Tipo_Contrato';
import RegTipo_Contrato from '../pages/RegTipo_Contrato';
import Tabela_Precos from '../pages/Tabela_Precos';
import RegTabela_Precos from '../pages/RegTabela_Precos';
import Cartao from '../pages/Cartao';
import Contas_Receber from '../pages/Contas_Receber';
import RegContas_Receber from '../pages/RegContas_Receber';
import Empresas from '../pages/Empresas';
import RegEmpresas from '../pages/RegEmpresas';
import Contratos_Empresas from '../pages/Contratos_Empresas';
import RegContratos_Empresas from '../pages/RegContratos_Empresas';
import Cobranca from '../pages/Cobranca';
import Callback from '../pages/Callback';
import Sedes from '../pages/Sedes';
import RegSedes from '../pages/RegSedes';
import Clinicas from '../pages/Clinicas';
import RegClinicas from '../pages/RegClinicas';
import Especialidades from '../pages/Especialidades';
import RegEspecialidades from '../pages/RegEspecialidades';
import Feriados from '../pages/Feriados';
import RegFeriados from '../pages/RegFeriados';
import Origens_Contatos from '../pages/Origens_Contatos';
import RegOrigens_Contatos from '../pages/RegOrigens_Contatos';
import Sub_Origem from '../pages/Sub_Origem';
import RegSub_Origem from '../pages/RegSub_Origem';
import Profissoes from '../pages/Profissoes';
import RegProfissoes from '../pages/RegProfissoes';
import Promocoes from '../pages/Promocoes';
import RegPromocoes from '../pages/RegPromocoes';
import RenovaContratos from '../pages/RenovaContratos';
import Debito_Conta from '../pages/Debito_Conta';
import Cobranca_Lote_Debito from '../pages/Cobranca_Lote_Debito';
import RegCobranca_Lote_Debito from '../pages/RegCobranca_Lote_Debito';
import Plano_Contas from '../pages/Plano_Contas';
import RegPlano_Contas from '../pages/RegPlano_Contas';
import Boletos from '../pages/Boletos';
import Retornos from '../pages/Retornos';
import Pagamentos from '../pages/Pagamentos';
import Cartoes from '../pages/Cartoes';
import CartoesPagamento from '../pages/CartoesPagamento';
import CancelamentoContrato from '../pages/CancelamentoContrato';
import FaturamentoEmpresa from '../pages/FaturamentoEmpresa';
import Documentos from '../pages/Documentos';
import RegDocumentos from '../pages/RegDocumentos';
import RegBaixaCtr from '../pages/RegBaixaCtr';
import Situacoes_Contrato from '../pages/Situacoes_Contrato';
import RegSituacoes_Contrato from '../pages/RegSituacoes_Contrato';
import NotasFiscais from '../pages/NotasFiscais';
import RegNotasFiscais from '../pages/RegNotasFiscais';
import DemonstrativoAnual from '../pages/DemonstrativoAnual';
import RegFaturamentoEmpresa from '../pages/RegFaturamentoEmpresa';
import Controle_Caixa from '../pages/Controle_Caixa';
import RelCategoria from '../pages/RelCategoria';
import RelRepresentante from '../pages/RelRepresentante';
import RelFpg from '../pages/RelFpg';
import RelAnalitico from '../pages/RelAnalitico';
import RelRepCategoria from '../pages/RelRepCategoria';
import RelComissaoRepresentantes from '../pages/RelComissaoRepresentantes';
import RelGeralContas from '../pages/RelGeralContas';
import RelContasSintetico from '../pages/RelContasSintetico';


export const routes = [
    {
        path: '/cartao',
        component: Cartao,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/callback',
        component: Callback,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/forgotPw',
        component: ForgotPw,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },

    {
        path: '/changePw',
        component: ChangePw,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },

    {
        path: '/login',
        component: Login,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/home',
        component: Home,
        protected: true,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/usuarios',
        component: Usuarios,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Usuários',

    },
    {
        path: '/usuarios/registro',
        component: RegUsuarios,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/grupo_usuarios',
        component: Grupo_Usuarios,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Grupos de Usuários'
    },
    {
        path: '/grupo_usuarios/registro',
        component: RegGrupo_Usuarios,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/unidades',
        component: Unidades,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Unidades',
        type: 'auxiliares'
    },
    {
        path: '/unidades/registro',
        component: RegUnidades,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/bancos',
        component: Bancos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Bancos',
        type: 'financeiros'

    },
    {
        path: '/bancos/registro',
        component: RegBancos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/grupo_conta',
        component: Grupo_Conta,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Grupos de Contas',
        type: 'financeiros'

    },
    {
        path: '/grupo_conta/registro',
        component: RegGrupo_Conta,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/tipo_conta',
        component: Tipo_Conta,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Tipos de Contas',
        type: 'financeiros'

    },
    {
        path: '/tipo_conta/registro',
        component: RegTipo_Conta,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/categoria_representantes',
        component: Categoria_Representantes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Categorias de Representantes',
        type: 'financeiros'

    },
    {
        path: '/categoria_representantes/registro',
        component: RegCategoria_Representantes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/contas',
        component: Contas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Contas',
        type: 'operacional'

    },
    {
        path: '/contas/registro',
        component: RegContas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/importacao',
        component: Importacao,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/clientes',
        component: Clientes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Clientes',
        type: 'cadastro'

    },
    {
        path: '/clientes/registro',
        component: RegClientes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/contratos',
        component: Contratos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Contratos',
        type: 'operacional'

    },
    {
        path: '/contratos/registro',
        component: RegContratos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/paises',
        component: Paises,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Países',
        type: 'gerais'

    },
    {
        path: '/paises/registro',
        component: RegPaises,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/estados',
        component: Estados,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Estados',
        type: 'gerais'

    },
    {
        path: '/estados/registro',
        component: RegEstados,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/cidades',
        component: Cidades,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Cidades',
        type: 'gerais'

    },
    {
        path: '/cidades/registro',
        component: RegCidades,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/representantes',
        component: Representantes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Representantes',
        type: 'auxiliares'

    },
    {
        path: '/representantes/registro',
        component: RegRepresentantes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/categoria_clientes',
        component: Categoria_Clientes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Categoria de Clientes',
        type: 'auxiliares'

    },
    {
        path: '/categoria_clientes/registro',
        component: RegCategoria_Clientes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/bandeira_cartao',
        component: Bandeira_Cartao,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Bandeira de Cartões',
        type: 'auxiliares'

    },
    {
        path: '/bandeira_cartao/registro',
        component: RegBandeira_Cartao,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/campanhas',
        component: Campanhas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Campanhas',
        type: 'auxiliares'

    },
    {
        path: '/campanhas/registro',
        component: RegCampanhas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/formas_pagamento',
        component: Formas_Pagamento,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Formas de Pagamento',
        type: 'financeiros'

    },
    {
        path: '/formas_pagamento/registro',
        component: RegFormas_Pagamento,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/motivos_cancelamento',
        component: Motivos_Cancelamento,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Motivos de Cancelamento',
        type: 'auxiliares'

    },
    {
        path: '/motivos_cancelamento/registro',
        component: RegMotivos_Cancelamento,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/situacao_historico',
        component: Situacao_Historico,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Situações de Histórico',
        type: 'auxiliares'

    },
    {
        path: '/situacao_historico/registro',
        component: RegSituacao_Historico,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/tipo_historico',
        component: Tipo_Historico,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Tipos de Histórico',
        type: 'auxiliares'

    },
    {
        path: '/tipo_historico/registro',
        component: RegTipo_Historico,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/tipo_solicitacao',
        component: Tipo_Solicitacao,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Tipos de Solicitação',
        type: 'auxiliares'

    },
    {
        path: '/tipo_solicitacao/registro',
        component: RegTipo_Solicitacao,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/tipo_formapagamento',
        component: Tipo_FormaPagamento,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Tipos de Formas de Pagamento',
        type: 'financeiros'

    },
    {
        path: '/tipo_formapagamento/registro',
        component: RegTipo_FormaPagamento,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/tipo_contrato',
        component: Tipo_Contrato,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Tipos de Contrato',
        type: 'auxiliares'

    },
    {
        path: '/tipo_contrato/registro',
        component: RegTipo_Contrato,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/tabela_precos',
        component: Tabela_Precos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Tabela de Preços',
        type: 'financeiros'

    },
    {
        path: '/tabela_precos/registro',
        component: RegTabela_Precos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/contas_receber',
        component: Contas_Receber,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Contas a Receber',
        type: 'operacional'

    },
    {
        path: '/contas_receber/registro',
        component: RegContas_Receber,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/dependentes',
        component: Clientes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true,
    },
    {
        path: '/dependentes/registro',
        component: RegClientes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/empresas',
        component: Empresas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Empresas',
        type: 'cadastro'

    },
    {
        path: '/empresas/registro',
        component: RegEmpresas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/contratos_empresas',
        component: Contratos_Empresas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Contratos Empresas',
        type: 'operacional'

    },
    {
        path: '/contratos_empresas/registro',
        component: RegContratos_Empresas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/cobranca',
        component: Cobranca,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Cobrança',
        type: 'operacional'

    },


    {
        path: '/sedes',
        component: Sedes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Sedes',
        type: 'auxiliares'
    },
    {
        path: '/sedes/registro',
        component: RegSedes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/clinicas',
        component: Clinicas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Clínicas',
        type: 'auxiliares'
    },
    {
        path: '/clinicas/registro',
        component: RegClinicas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/especialidades',
        component: Especialidades,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Especialidades',
        type: 'auxiliares'
    },
    {
        path: '/especialidades/registro',
        component: RegEspecialidades,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/feriados',
        component: Feriados,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Feriados',
        type: 'auxiliares'
    },
    {
        path: '/feriados/registro',
        component: RegFeriados,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },



    {
        path: '/origens_contatos',
        component: Origens_Contatos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Origens Contatos',
        type: 'auxiliares'
    },
    {
        path: '/origens_contatos/registro',
        component: RegOrigens_Contatos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/sub_origem',
        component: Sub_Origem,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'SubOrigem Contatos',
        type: 'auxiliares'
    },
    {
        path: '/sub_origem/registro',
        component: RegSub_Origem,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/profissoes',
        component: Profissoes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Profissões',
        type: 'auxiliares'
    },
    {
        path: '/profissoes/registro',
        component: RegProfissoes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/promocoes',
        component: Promocoes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Promoções',
        type: 'auxiliares'
    },
    {
        path: '/promocoes/registro',
        component: RegPromocoes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/renova_contratos',
        component: RenovaContratos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true,
        name: 'Renovação de Contratos',
        type: 'operacional'

    },

    {
        path: '/debito_conta',
        component: Debito_Conta,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Cobrança Débito Conta',
        type: 'operacional'

    },

    {
        path: '/cobranca_lote_debito',
        component: Cobranca_Lote_Debito,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Lote Débitos',
        type: 'auxiliares'
    },
    {
        path: '/cobranca_lote_debito/registro',
        component: RegCobranca_Lote_Debito,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/plano_contas',
        component: Plano_Contas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Plano Contas',
        type: 'auxiliares'
    },
    {
        path: '/plano_contas/registro',
        component: RegPlano_Contas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },


    {
        path: '/boletos',
        component: Boletos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Cobrança Boletos',
        type: 'operacional'

    },
    {
        path: '/retornos',
        component: Retornos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Retornos Bancários',
        type: 'operacional'

    },
    {
        path: '/pagamentos',
        component: Pagamentos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Pagamentos',
        type: 'operacional'
    },
    {
        path: '/cartoes',
        component: Cartoes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Cartoes',
        type: 'operacional'
    },
    {
        path: '/pagamento_adesao',
        component: CartoesPagamento,
        protected: false,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/cancelamento_contrato',
        component: CancelamentoContrato,
        protected: true,
        exact: true,
        checkPermission: false,
        register: false
    },
    {
        path: '/faturamento_empresa',
        component: FaturamentoEmpresa,
        protected: true,
        exact: true,
        checkPermission: false,
        register: false,
        name: 'Faturamento Empresa',
        type: 'operacional'
    },
    {
        path: '/documentos',
        component: Documentos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Documentação Cliente',
        type: 'operacional'

    },
    {
        path: '/documentos/registro',
        component: RegDocumentos,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/contas_receber/baixa',
        component: RegBaixaCtr,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },

    {
        path: '/situacao_contrato',
        component: Situacoes_Contrato,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Situação Contrato',
        type: 'operacional'
    },
    {
        path: '/situacao_contrato/registro',
        component: RegSituacoes_Contrato,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/notas_fiscais',
        component: NotasFiscais,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Notas Fiscais',
        type: 'operacional'
    },
    {
        path: '/notas_fiscais/registro',
        component: RegNotasFiscais,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/demonstrativos_anuais',
        component: DemonstrativoAnual,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Demonstrativos Anuais',
        type: 'operacional'
    },
    {
        path: '/faturamento_empresa/registro',
        component: RegFaturamentoEmpresa,
        protected: true,
        exact: true,
        checkPermission: true,
        register: true
    },
    {
        path: '/controle_caixa',
        component: Controle_Caixa,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Controle de Caixa',
        type: 'operacional'
    },
    {
        path: '/relatorio_categoria',
        component: RelCategoria,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Por Categoria',
        type: 'relatorios',
        submenu: 'vendas_representantes'
    },
    {
        path: '/relatorio_representante',
        component: RelRepresentante,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Por Representante',
        type: 'relatorios',
        submenu: 'vendas_representantes'
    },
    {
        path: '/relatorio_fpg',
        component: RelFpg,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Por Forma de Pagamento',
        type: 'relatorios',
        submenu: 'vendas_representantes'
    },
    {
        path: '/relatorio_analitico',
        component: RelAnalitico,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Por Representante - Analítico',
        type: 'relatorios',
        submenu: 'vendas_representantes'
    },
    {
        path: '/relatorio_representante_categoria',
        component: RelRepCategoria,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Receitas por Representante/Categoria',
        type: 'relatorios',
        submenu: 'vendas_representantes'
    },
    {
        path: '/relatorio_comissao_representantes',
        component: RelComissaoRepresentantes,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Receitas por Representante',
        type: 'relatorios',
        submenu: 'vendas_representantes'
    },
    {
        path: '/relatorio_geral_contas',
        component: RelGeralContas,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Geral',
        type: 'relatorios',
        submenu: 'contas'
    },
    {
        path: '/relatorio_contas_sintetico',
        component: RelContasSintetico,
        protected: true,
        exact: true,
        checkPermission: true,
        register: false,
        name: 'Sintético',
        type: 'relatorios',
        submenu: 'contas'
    },

];

export const fallbackRoute = Home

